import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureAxios } from '@common/apis/baseApi';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
configureAxios(false);
root.render(<App />);
